import React from 'react';
/*
To import child routes, insert the following code:
import { <childComponent>Routes } from './components/<child-folder>';
*/

import { Route } from '@plasma/ui.application.router';

const PlannedDemandPage = React.lazy(() => import('.'));

export const plannedDemandPageRoutes = [
  new Route({
    path: 'planned-demand-page/:planId/:suffix?/:planName?',
    element: PlannedDemandPage,
    children: [],
  }),
];
